import api from '@/api/common'
import { COMMON_SET_CURRENCIES, COMMON_SET_PERSONALITIES } from './mutations'

export default {
  async loadPersonalities ({ commit }) {
    try {
      const { personalities } = await api.loadPersonalities()
      commit(COMMON_SET_PERSONALITIES, personalities)
    } catch (error) {
      throw new Error(error.message)
    }
  },
  async loadCurrencies ({ commit }) {
    try {
      const { currencies } = await api.loadCurrencies()
      commit(COMMON_SET_CURRENCIES, currencies)
    } catch (e) {
      throw new Error(e)
    }
  }
}
